module.exports = __webpack_public_path__ + "img/logo_de.1c5bef04.svg";